import React from 'react'
import PropTypes from 'prop-types'
import {Box, Image, Text, useMultiStyleConfig, Link as ChakraLink} from '@chakra-ui/react'
import {Link as RouteLink} from 'react-router-dom'
import Link from '@salesforce/retail-react-app/app/components/link'
import {noop} from '@salesforce/retail-react-app/app/utils/utils'
import {createGradientBackground} from '../../theme/components/project/list-menu-card'

const coverStyles = {objectFit: 'cover', w: '100%', h: '100%'}

const MenuCard = ({
    title,
    url,
    variant = 'default',
    image,
    svg,
    isAbsolute = false,
    isLink = false,
    handleClick = noop,
    customTitleColor,
}) => {
    const styles = useMultiStyleConfig('ListMenuCard', {variant: variant})

    const isGradientVariant = variant === 'promo' || variant === 'filter'

    const handleCardClick = (e) => {
        handleClick(e)
    }

    const Card = (
        <Box {...styles.container} sx={styles.containerBreakpoint} onClick={handleCardClick}>
            <Text
                {...styles.title}
                sx={styles.titleBreakpoint}
                color={customTitleColor ? customTitleColor : styles?.title?.color}
            >
                {title}
            </Text>
            <Box
                {...styles.image}
                sx={
                    isGradientVariant && image?.url
                        ? {
                              ...styles.image,
                              ...createGradientBackground(image.url),
                          }
                        : styles.image
                }
            >
                {!isGradientVariant && image && (
                    <Image src={image?.url} alt={title} sx={coverStyles} loading="lazy" />
                )}
                {!image && svg}
            </Box>
        </Box>
    )

    if (!isLink) {
        return Card
    }

    if (isAbsolute) {
        return (
            <ChakraLink
                href={url}
                _hover={{textDecoration: 'none'}}
                isExternal
                target="_blank"
                rel="noreferrer"
            >
                {Card}
            </ChakraLink>
        )
    }

    return (
        <Link as={RouteLink} to={url} _hover={{textDecoration: 'none'}}>
            {Card}
        </Link>
    )
}

MenuCard.propTypes = {
    title: PropTypes.string,
    url: PropTypes.string,
    image: PropTypes.shape({
        url: PropTypes.string.isRequired,
    }),
    svg: PropTypes.element,
    isAbsolute: PropTypes.bool,
    isLink: PropTypes.bool,
    customTitleColor: PropTypes.string,
    handleClick: PropTypes.func,
    variant: PropTypes.oneOf(['default', 'filter', 'promo', 'secondary', 'simpleLink', 'variant']),
}

export {MenuCard}
